import React, { PropsWithChildren } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon, EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import Utilities from '@util/Utilities';
import FormButtonStyleState from '@app/component/form/button/FormButtonStyleState';
import { Link } from 'react-router-dom';

type LinkItem = {
	name: string,
	disabled?: boolean
	link?: string,
	icon?: React.JSX.Element,
	onClick?: () => any
}

type Props = {
	items: LinkItem[],
	state?: FormButtonStyleState,
	portal?: boolean,
	className?: string
	buttonClassName?: string
	menuItemClassName?: string,
	description?: string,
	disabled?: boolean
}

const ButtonLinkList: React.FunctionComponent<PropsWithChildren<Props>> = ({
																																						 children,
																																						 items,
																																						 state = 'white',
																																						 portal = false,
																																						 className,
																																						 buttonClassName,
																																						 description,
																																						 menuItemClassName,
																																						 disabled = false,
																																					 }) => {


	return <Menu as="div" className="relative inline-block text-left">
		<MenuButton
			className={!!children ? (!!className ? className :
					Utilities.classNames('btn', Utilities.NVL(!!state, state, '', 'btn-'), buttonClassName ? buttonClassName : ''))
				: ''}>
			{children}
			{!!children && !disabled && <ChevronDownIcon className="-mr-1 ml-1 h-5 w-5" aria-hidden="true" />}
			{!children && <EllipsisVerticalIcon className="h-4 w-4" aria-hidden="true" />}
		</MenuButton>

		<MenuItems anchor="bottom end"
							 className="z-10 -mr-1 w-52 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none divide-y divide-gray-100 mt-2">
			{!!description && <div className="px-4 py-3">
				<p className="text-xs text-gray-500">{description}</p>
			</div>}
			{!disabled && <div className="py-1">
				{items.map((item) => (
					<MenuItem key={item.name}>
						{({ focus }) => (
							<Link
								to={item.link!}
								onClick={item.onClick}
								className={Utilities.classNames(
									!item.disabled && focus ? 'bg-gray-100 text-gray-900' : '',
									menuItemClassName ?? 'block px-4 py-2 text-xs cursor-pointer',
									item.disabled ? 'pointer-events-none text-gray-400' : 'text-gray-700',
								)}
							>
								{!!item.icon ? <div
									className={Utilities.classNames('flex items-center gap-x-2', item.disabled ? 'opacity-60' : '')}>
									{item.icon}
									<span className="font-semibold block">{item.name}</span>
								</div> : item.name}
							</Link>
						)}
					</MenuItem>
				))}
			</div>}
		</MenuItems>
	</Menu>;
};

export default ButtonLinkList;